import axios from "@/plugins/axios";

let url = "/api/console/ksnet";

export default {
    getBalance(data){
        return axios.get(`${url}/balance`, data).then(result => result.data);
    },
}
